import { dictionary, format, locale, number } from "svelte-i18n";
import * as locales from "../../locales";

/**
 * Load messages for current locale
 *
 * @param {string} _locale Locale from experience JSON
 * @returns {void}
 */
function setupI18n(_locale = "en") {
  // eslint-disable-next-line no-underscore-dangle
  let messages = locales[_locale];

  if (!messages) {
    // eslint-disable-next-line no-console
    console.warn(`Missing translations file for ${_locale}`);
    messages = {};
  }

  dictionary.set({ [_locale]: messages });
  locale.set(_locale);
}

export { format as _, format, locale, number, setupI18n };
